var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageCardIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1455_20489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.0957 12.5745V32.4295C6.0957 33.4264 6.90383 34.2345 7.9007 34.2345H22.3407H32.3041H36.7807C37.7776 34.2345 38.5857 33.4264 38.5857 32.4295V21.9605V12.5745C38.5857 11.5777 37.7776 10.7695 36.7807 10.7695H22.3407H10.157H7.9007C6.90383 10.7695 6.0957 11.5777 6.0957 12.5745Z",
    fill: "url(#paint0_linear_1455_20489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4108 26.0291L7.24724 30.6176C6.45788 31.4875 7.07512 32.881 8.24977 32.881H33.2732C34.4479 32.881 35.0651 31.4875 34.2757 30.6176L26.2765 21.8021C25.7393 21.21 24.8087 21.21 24.2715 21.8021L17.9284 28.7924C17.3912 29.3845 16.4606 29.3845 15.9233 28.7924L13.4159 26.0291C12.8787 25.4371 11.9481 25.4371 11.4108 26.0291Z",
    fill: "url(#paint1_linear_1455_20489)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.6987,
    cy: 23.1791,
    r: 2.48187,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1455_20489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3189 19.7777C32.6296 20.3031 31.7903 20.5941 30.9237 20.6083C28.1012 20.6083 26.4883 17.3825 26.4883 17.3825C26.9898 16.4478 27.6855 15.6312 28.5286 14.9874M30.077 14.2535C30.3545 14.1886 30.6387 14.1561 30.9237 14.1567C33.7463 14.1567 35.3592 17.3825 35.3592 17.3825C35.1144 17.8404 34.8225 18.2715 34.4882 18.6688M31.7786 18.2374C31.6678 18.3562 31.5343 18.4515 31.3859 18.5177C31.2375 18.5838 31.0773 18.6193 30.9149 18.6222C30.7525 18.6251 30.5911 18.5952 30.4405 18.5343C30.2899 18.4735 30.1531 18.3829 30.0382 18.2681C29.9233 18.1532 29.8328 18.0164 29.7719 17.8657C29.7111 17.7151 29.6812 17.5538 29.6841 17.3914C29.6869 17.2289 29.7225 17.0688 29.7886 16.9204C29.8547 16.772 29.9501 16.6384 30.0689 16.5277",
    stroke: "white",
    strokeWidth: 0.806446,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4883 12.9468L35.3592 21.8177",
    stroke: "white",
    strokeWidth: 0.806446,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1455_20489",
    x: 23.665,
    y: 10.7416,
    width: 14.5822,
    height: 13.3405,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.465369
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1455_20489"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1455_20489",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1455_20489",
    x1: 4.94184,
    y1: 14.1292,
    x2: 38.7238,
    y2: 43.1684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E372FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1455_20489",
    x1: 20.7615,
    y1: 20.6973,
    x2: 20.7615,
    y2: 32.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1455_20489"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.09375,
    y: 10.7695,
    width: 32.49,
    height: 23.465,
    rx: 1.805,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCardIcon6);
export default __webpack_public_path__ + "static/media/message_card_icon6.151d6e5c7f6782bb17dfb8dfcf513feb.svg";
export { ForwardRef as ReactComponent };